<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import versionChecker from './core/services/version-checker.service';

export default {
  name: 'app',
  mounted() {
    // Initialize version checking after app is mounted
    this.$nextTick(() => {
      versionChecker.start(async () => {
        // Callback when version mismatch is detected
        const message = this.$i18n.t('A new version of the application is available. Would you like to reload now?');
        const title = this.$i18n.t('New Version Available');
        const confirmed = await this.$confirm(
          message,
          null, // successMessage
          null, // handler
          null, // handlerParams
          title,
          this.$i18n.t('Reload'), // submitBtnText
          this.$i18n.t('Close') // cancelBtnText
        );

        if (confirmed) {
          // User clicked Reload
          window.location.reload();
        } else {
          // User clicked Close - stop version checking
          versionChecker.stop();
        }
      });
    });
  }
}
</script>

<style lang="scss">
html, body, #app {
  height: 100%;
}
</style>
